import { render, staticRenderFns } from "./patientTemplate.vue?vue&type=template&id=ebea4a28&scoped=true&"
import script from "./patientTemplate.vue?vue&type=script&lang=ts&"
export * from "./patientTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./patientTemplate.vue?vue&type=style&index=0&id=ebea4a28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebea4a28",
  null
  
)

export default component.exports